import React, { Suspense, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { LimiteParte, lazyConReintento } from "../../helpers/lazy-con-reintento";

/**
 * `RichMarkdown` con su motor (react-markdown + remark, ~150 KB) bajado al mostrarse (#1717 R12).
 *
 * En el arranque solo lo usaban los diálogos de Términos (el "léelos" del registro y el gate de
 * aceptación), que casi nadie abre al entrar: ese peso lo pagaba cada lead que abría el link de
 * registro. Si el motor no baja (sin red), el texto se muestra plano: los términos se leen igual.
 * Nunca recarga la página (`recargar: false`), ni tras un deploy: el lead perdería lo que escribió en
 * el formulario de registro (F8 del revisor v3).
 * Cubre R12 — .claude/specs/1717-velocidad/
 */
const RichMarkdown = lazyConReintento(() => import("./RichMarkdown"), { recargar: false });

const RichMarkdownDiferido = ({ children, ...props }) => {
  const [fallo, setFallo] = useState(false);
  if (fallo) {
    return <Typography component="div" sx={{ whiteSpace: "pre-wrap", fontSize: 14 }}>{children}</Typography>;
  }
  return (
    <LimiteParte onFallo={() => setFallo(true)}>
      <Suspense
        fallback={
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size={24} />
          </Box>
        }
      >
        <RichMarkdown {...props}>{children}</RichMarkdown>
      </Suspense>
    </LimiteParte>
  );
};

export default RichMarkdownDiferido;
